module.exports = __webpack_public_path__ + "static/media/layslla-ferreira.38784cc4.jpeg";